export class FileUpload { 
    file: File; 
    applyToAll: boolean;
   }